const API_BASE = ''

export class ApiError extends Error {
  readonly status: number
  readonly code: string | null
  readonly existing: { namespace: string; name: string } | null

  constructor(
    message: string,
    status: number,
    code?: string | null,
    existing?: { namespace: string; name: string } | null,
  ) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code ?? null
    this.existing = existing ?? null
  }
}

async function fetcher<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const isForm = typeof FormData !== 'undefined' && options?.body instanceof FormData
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      ...(isForm ? {} : { 'Content-Type': 'application/json' }),
      ...options?.headers,
    },
    credentials: 'include',
  })

  if (!res.ok) {
    const err = (await res.json().catch(() => ({ error: 'Request failed' }))) as {
      error?: string
      code?: string
      existing?: { namespace: string; name: string }
    }
    throw new ApiError(
      err.error || `HTTP ${res.status}`,
      res.status,
      err.code ?? null,
      err.existing ?? null,
    )
  }

  return res.json() as Promise<T>
}

export const api = {
  get: <T>(path: string) => fetcher<T>(path, { method: 'GET' }),
  post: <T>(path: string, body: unknown) =>
    fetcher<T>(path, { method: 'POST', body: JSON.stringify(body) }),
  put: <T>(path: string, body: unknown) =>
    fetcher<T>(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: <T>(path: string, body: unknown) =>
    fetcher<T>(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: <T>(path: string, body?: unknown) =>
    fetcher<T>(path, {
      method: 'DELETE',
      body: body === undefined ? undefined : JSON.stringify(body),
    }),
  upload: <T>(path: string, body: FormData, method: 'POST' | 'PUT' = 'POST') =>
    fetcher<T>(path, { method, body }),
}
